// Real photography (Unsplash) used with deliberate treatment: dark overlays, blue/red grade, clipped frames.
// No faces, no cars, no police, no handcuffs — only abstract lights, wet street, dark water, ink glow.
export const PHOTOS = {
  wetStreet:
    'https://images.unsplash.com/photo-1519638399535-1b036603ac77?auto=format&fit=crop&w=2400&q=70',
  wetStreetSm:
    'https://images.unsplash.com/photo-1519638399535-1b036603ac77?auto=format&fit=crop&w=900&q=60',
  inkGlow:
    'https://images.unsplash.com/photo-1541701494587-cb58502866ab?auto=format&fit=crop&w=1600&q=70',
  darkWater:
    'https://images.unsplash.com/photo-1478760329108-5c3ed9d495a0?auto=format&fit=crop&w=1600&q=70',
};
